import { useEditorState } from "@/store";
import { Actions, TabNode } from "flexlayout-react";

export const updateBlocklyTabName = () => {
	try {
		const model = useEditorState.getState().layout.model;
		const blocklyTabId = "main-blockly-tab";
		const node = model.getNodeById(blocklyTabId) as TabNode;
		if (node) {
			const nodeName = node.getName();
			if (!nodeName.endsWith("*"))
				model.doAction(Actions.renameTab(blocklyTabId, nodeName + "*"));
		}
	} catch (error) {
		// Do nothing
	}
}

export const clearBlocklyTabName = () => {
	try {
		const model = useEditorState.getState().layout.model;
		const blocklyTabId = "main-blockly-tab";
		const node = model.getNodeById(blocklyTabId) as TabNode;
		if (node) {
			const nodeName = node.getName();
			if (nodeName.endsWith("*"))
				model.doAction(Actions.renameTab(blocklyTabId, nodeName.slice(0, -1)));
		}
	} catch (error) {
		// Do nothing
	}
}



export const updateMonacoTabName = () => {
	try {
		const model = useEditorState.getState().layout.model;
		let monacoTabId = "main-editor-tab";
		let node = model.getNodeById(monacoTabId) as TabNode;

		if (!node) {
			monacoTabId = "blockly-preview-tab";
			node = model.getNodeById(monacoTabId) as TabNode;
		}

		if (node) {
			const nodeName = node.getName();
			if (!nodeName.endsWith("*"))
				model.doAction(Actions.renameTab(monacoTabId, nodeName + "*"));
		}
	} catch (error) {
		//Do nothing
	}
}

export const clearMonacoTabName = () => {
	try {
		const model = useEditorState.getState().layout.model;
		let monacoTabId = "main-editor-tab";
		let node = model.getNodeById(monacoTabId) as TabNode;

		if (!node) {
			monacoTabId = "blockly-preview-tab";
			node = model.getNodeById(monacoTabId) as TabNode;
		}
		if (node) {
			const nodeName = node.getName();
			if (nodeName.endsWith("*"))
				model.doAction(Actions.renameTab(monacoTabId, nodeName.slice(0, -1)));
		}
	} catch (error) {
		// Do nothing
	}
}